export enum StatusCode{
    kResponseSuccess = 200,
    kResponseCreated = 201,
    kResponseAccepted = 202,
    kResponseNoContent = 204,
    kUnprocessableEntity = 422,
};